import React from 'react';
import HiddenInput from 'shared/components/HiddenInput';

const QuoteConfigKey = (props) => {
  const { parameters, groupName } = props;
  const name = 'quote_config_key';
  return (
    <HiddenInput
      name={name}
      value={parameters[name]}
      groupName={groupName} />
  );
};

export default QuoteConfigKey;
